import React, { useEffect, useState } from 'react'
import ModalListaSeleccionCentroCostoPI from '../procedimientosIndividuales/ModalListaSeleccionCentroCostoPI'
import ModalListaSeleccionImpuesto from './ModalListaSeleccionImpuesto'
import { postupdateProcedimientoNoOperacionales } from '../../../services/Contratacion'
import ModalNPCCentros from '../procedimientosIndividuales/ModalNPCCentros'
import ModalNPCProcedimientos from '../procedimientosIndividuales/ModalNPCProcedimientos'

const ModalModifcarProcedimientosNoOperacionales = ({setmodalOnModificarProcedimientosNoOperacionales,setactualizarDataProcedimientosNoOperacionales,dataUnProcedimientoNoOperacional}) => {
    const [loading, setloading] = useState(true) 
      const [modalOnImpuesto, setModalOnImpuesto] = useState(false)
      const [modalOnCentroCosto, setModalOnCentroCosto] = useState(false)      
      const [errorDescripcion, setErrorDescripcion] = useState('')
      const [errorCentroCosto, setErrorCentroCosto] = useState('')
      const [errorImpuesto, setErrorImpuesto] = useState('')    
      const [modalOnNPCCentros, setmodalOnNPCCentros]=useState(false)  
      const [modalOnNPCProcedimientos, setmodalOnNPCProcedimientos]=useState(false)
      const [dataCentroCosto, setDataCentroCosto] = useState({
        "CNCCOD": dataUnProcedimientoNoOperacional.CNCCOD,
        "CnCDsc": dataUnProcedimientoNoOperacional.CnCDsc
      })
      const [dataImpuesto, setDataImpuesto] = useState({
        "IMPCOD": dataUnProcedimientoNoOperacional.IMPCOD,
        "impDsc": dataUnProcedimientoNoOperacional.impDsc
      })
    
      const handleCancelarClick = () => {        
        setmodalOnModificarProcedimientosNoOperacionales(false)
      }
    
      const handleOnclickCentroCosto = () => {
        setModalOnCentroCosto(true)
      }
    
      const handleOnclickImpuesto = () => {
        setModalOnImpuesto(true)
      }
    
      const passDataCentroCosto = (data) => {
        console.log(data, 'data centro costo')
        setErrorCentroCosto('')
        setDataCentroCosto({
          "CNCCOD": data.CNCCOD,
          "CnCDsc": data.CnCDsc
        })
        setModalOnCentroCosto(false)
      }
    
      const passDataImpuesto = (data) => {
        console.log(data, 'data impuesto')
        setErrorImpuesto('')
        setDataImpuesto({
          "IMPCOD": data.IMPCOD,
          "impDsc": data.impDsc
        })
        setModalOnImpuesto(false)
      }
    
    
    
      const handleOnchangeDescripcion=(e)=>{
        if(e.target.value.trim()===''){
          setErrorDescripcion('Requiere descripcion')
        }else{
          setErrorDescripcion('')
        }
      }
    
      const handleOnsubmitModificarProcedimientosNoOperacionales=(e)=>{
        e.preventDefault()
        if(e.target.codigo.value.trim()!=='' && e.target.descripcion.value.trim()!=='' && dataCentroCosto.CNCCOD.trim()!=='' && dataImpuesto.IMPCOD.trim()!==''){
          const insert={
            "PRCODI": e.target.codigo.value,
            "PrNomb": e.target.descripcion.value,
            "PrMCCodi": dataCentroCosto.CNCCOD,
            "IMPCOD": dataImpuesto.IMPCOD,
            "PrSta": e.target.estado.value
          }
          console.log(insert)
          setloading(false)
          postupdateProcedimientoNoOperacionales(insert).then((res)=>{
            console.log(res.data.success)
            setmodalOnModificarProcedimientosNoOperacionales(false)
            setactualizarDataProcedimientosNoOperacionales(insert)
            setloading(true)
          })       
        }
        }

        const handleOnClickNPCCentros=()=>{
          setmodalOnNPCCentros(true)
        }

        const handleOnClickNPCProcedimientos=()=>{
          setmodalOnNPCProcedimientos(true)
        }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
       <div className="sm:h-[calc(100%)] max-w-7xl   mx-auto relative w-auto pointer-events-none ">
        <div className=" max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#437cdc]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Modificar Procedimientos No Operacionales
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative px-2">
            <form onSubmit={handleOnsubmitModificarProcedimientosNoOperacionales}>
              <div className="flex py-2 text-left">
                <div className="w-1/3">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código
                  </label>
                  <input                     
                    disabled={true}  
                    defaultValue={dataUnProcedimientoNoOperacional.PRCODI}           
                    type="text"
                    name="codigo"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    
                  </div>
                  <div className="w-2/3 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción
                  </label>
                  <textarea
                    onChange={handleOnchangeDescripcion}    
                    defaultValue={dataUnProcedimientoNoOperacional.PrNomb}            
                    type="text"
                    name="descripcion"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorDescripcion}
                  </label>
                  </div>
                  
              </div>

              <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                     Codigo de impuesto
                    </label>
                    <input       
                      onFocus={handleOnclickImpuesto}
                      value={dataImpuesto.IMPCOD}                                
                      type="text"
                      name="centroCosto"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorImpuesto}
                  </label>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Descripción de impuesto
                    </label>
                    <input       
                      disabled={true}
                      value={dataImpuesto.impDsc}          
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Centro costo codigo
                    </label>
                    <input       
                      onFocus={handleOnclickCentroCosto}
                      value={dataCentroCosto.CNCCOD}          
                      type="text"
                      name="centroCosto"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorCentroCosto}
                  </label>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Centro costo
                    </label>
                    <input       
                      disabled={true}
                      value={dataCentroCosto.CnCDsc}          
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                </div>
              
              <div className="flex py-2 text-left">
              <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Estado
                  </label>
                  <select                    
                    type="text"      
                    defaultValue={dataUnProcedimientoNoOperacional.PrSta}             
                    name="estado"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="S">Activo</option>
                        <option value="N">Inactivo</option>
                  </select>
                  </div>
                
                  
                </div>               
                
                
                <div className="flex justify-between items-center p-2 border-t border-gray-200 rounded-b-md">
                  {/* <!-- Div para el botón 'lista' alineado a la izquierda --> */}
  <div>
    <button
      type="button"
      onClick={handleOnClickNPCCentros}
      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
    >
      NPC Centros
    </button>
    <button
      onClick={handleOnClickNPCProcedimientos}
      type="button"
      className="inline-block px-4 ml-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
    >
      NPC Procedimientos
    </button>
  </div>
  <div className='text-right'>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
            </div>
          </div>
                
            </form>
            
          </div>
          
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }      
      {modalOnCentroCosto? <ModalListaSeleccionCentroCostoPI setmodalOnCentroCosto={setModalOnCentroCosto} passDataCentroCosto={passDataCentroCosto}/>: null}
      {modalOnImpuesto? <ModalListaSeleccionImpuesto setModalOnImpuesto={setModalOnImpuesto} passDataImpuesto={passDataImpuesto}/>: null}
      {/* {informacionGuardadaCorrectamentePNoOp? <ModalInformacionGuardadaCorrectamentePNoOp setInformacionGuardadaCorrectamentePNoOp={setInformacionGuardadaCorrectamentePNoOp} setmodalOnCrearProcedimientosNoOperacionales={setmodalOnCrearProcedimientosNoOperacionales} setactualizarDataProcedimientosNoOperacionales={setactualizarDataProcedimientosNoOperacionales} actualizarDataPNoOp={actualizarDataPNoOp}/>: null} */}
      {/* {modalOnMensajeError? <ModalMensajeProcedimientosNoOperacionales mensajeError={mensajeError} setModalOnMensajeError={setModalOnMensajeError}/>: null} */}
      {modalOnNPCCentros? <ModalNPCCentros setmodalOnNPCCentros={setmodalOnNPCCentros} dataUnMaestroProcedimiento={dataUnProcedimientoNoOperacional}/>:null}
      {modalOnNPCProcedimientos? <ModalNPCProcedimientos setmodalOnNPCProcedimientos={setmodalOnNPCProcedimientos} dataUnMaestroProcedimiento={dataUnProcedimientoNoOperacional}/>:null}
      
    </div>
  )
}

export default ModalModifcarProcedimientosNoOperacionales